export default {
	claims: '/claims',
	denyClaim: (claimId: number) => `/claims/${claimId}`,
	claim: (claimAccessType: string) => `/claims/${claimAccessType}`,
	artistDiscographies: (id: string) => `/claims/artists/${id}/discographies`,
};
